import { createAction } from 'redux-actions';
import _ from 'lodash';
import Promise from 'bluebird';
import providers from '../provider';
import dataSourceConfigs from '../config/dataSourceConfigs';

export default createAction('LOAD_BROADCASTAREA_DATA', async ({ country, language }) => {
  const sources = {
    selectedTemplates: dataSourceConfigs.selectedTemplates,
    viaplayLiveStreams: dataSourceConfigs.viaplayLiveStreams,
    viasportLiveStreams: dataSourceConfigs.viasportLiveStreams,
    broadcastAreaFeed: _.get(dataSourceConfigs, `${country}.broadcastAreaFeed`),
    longformPrograms: dataSourceConfigs.longformPrograms,
  };

  const dataSources = _.mapValues(sources, (source) =>
    providers[source.provider]({
      config: source.config,
      country,
      language,
      limit: source.limit,
    })
  );

  const broadcastAreaData = await Promise.props(dataSources);

  return { broadcastAreaData };
});



// WEBPACK FOOTER //
// ./src/action/loadBroadcastAreaData.js